export * from './marquee-cell.component';
export * from './split-marquee/split-marquee.component';
export * from './full-marquee/full-marquee.component';



// WEBPACK FOOTER //
// ./src/angular-framework-client-components/components/marquee/marquee-cell/index.ts